import OutlinedButton from "../OutlinedButton";

export default function OutlinedToggleButton({ onIcon, isOn = false, onToggle, ...props}) {

    const onProps = { 
        icon: onIcon 
    }

    const displayProps = {
        onClick: onToggle,
        ...props,
        ...(
            isOn
                ? onProps
                : {}
        ),
        isActive: isOn,
    }

    return (
        <OutlinedButton {...displayProps} />
    );
}